/**
 * @class AbstractProblem
 */
export default class AbstractProblem {
    /**
     * @param {string} type
     * @param {string} message
     * @param {string} icon
     * @param {ItemInterface[]} items
     */
    constructor(type, message, icon, items) {
        this.type = type;
        this.message = message;
        this.icon = icon;
        this.items = items;
    }

    /**
     * @return {string}
     */
    getType() {
        return this.type;
    }

    /**
     * @return {string}
     */
    getMessage() {
        return this.message;
    }

    /**
     * @return {string}
     */
    getItems() {
        return this.items;
    }

    /**
     * @return {string}
     */
    getIcon() {
        return this.icon;
    }

    getBadgeType() {
        return 'danger';
    }
}
